module.exports = __webpack_public_path__ + "img/logo_channel.ed25a498.png";